export function SaturationIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M12 21C9.78333 21 7.89583 20.2458 6.3375 18.7375C4.77917 17.2292 4 15.3667 4 13.15C4 12.05 4.2125 11.025 4.6375 10.075C5.0625 9.125 5.64167 8.28333 6.375 7.55L12 2L17.625 7.55C18.3583 8.28333 18.9375 9.125 19.3625 10.075C19.7875 11.025 20 12.05 20 13.15C20 15.3667 19.2208 17.2292 17.6625 18.7375C16.1042 20.2458 14.2167 21 12 21ZM5.575 14H18.425C18.6417 12.85 18.5167 11.7917 18.05 10.825C17.5833 9.85833 17.1167 9.15 16.65 8.7L12 4.125L7.35 8.7C6.88333 9.15 6.41667 9.85833 5.95 10.825C5.48333 11.7917 5.35833 12.85 5.575 14Z'
        fill='currentColor'
      />
    </svg>
  )
}
